import { createAction, props } from "@ngrx/store";


export const viewTransactionStatusClicked = createAction(
    '[Confirmation Page] View transaction status clicked',
    props<{ accountId: string }>()
);

export const createAnotherRequestClicked = createAction(
    '[Confirmation Page] Create another request clicked',
    props<{ accountId: string }>()
);

export const updateTemplateNickname = createAction(
    '[Confirmation Page - Save as Template Modal] Nickname updated',
    props<{ nickname: string }>()
);